import styled from 'styled-components';

export const ContainerRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  margin: 10px 0px;
`;
